package com.fireavert.yardi.common_data.data_models

import kotlinx.serialization.Serializable

@Serializable
data class RateLimitInfo(
    val interfaceType: String,
    val rateType: String,
    val name: String,
    val limit: Int
)